
<template>
    <div class="animated fadeIn">
        <b-row>
        
            <b-col lg="12">
                <b-card v-if="tieneAcceso === false">
                    <div slot="header">
                        <strong>Asignar Liquidador</strong>
                    </div>
                    <b-row>
                        <b-col lg="12">
                            <p>Acceso restringido</p>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-card >
                    <div slot="header">
                            <strong>Asignación y Seguimiento de Liquidador</strong>
                    </div>
                    <b-container  fluid>        
                        <b-card>
                        <b-row>
                            <b-col sm="10"></b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label> Fecha Ingreso</label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.feingreso"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="8"></b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Nro. Aviso </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.nroaviso"  size="sm" disabled></b-form-input>
                            </b-col>

                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1" >
                                <label> Nro. Siniestro </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.nrosiniestro"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="10"></b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Estado </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.estado"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>    

                        <b-row>
                            
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Póliza </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.poliza"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Producto </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.producto"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Moneda </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.moneda"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>  

                        <b-row>
                            
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Asegurado </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.codasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.rutasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="3">
                                <b-form-input v-model="datosSiniestro.nomasegurado"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>  

                        <b-row>
                            
                            <b-col class="col-sm-per d-flex justify-content-end" sm ="1">
                                <label> Suj. Riesgo </label>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.codsujetoriesgo"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="1">
                                <b-form-input v-model="datosSiniestro.rutsujetoriesgo"  size="sm" disabled></b-form-input>
                            </b-col>
                            <b-col class="col-sm-per" sm ="3">
                                <b-form-input v-model="datosSiniestro.nomsujetoriesgo"  size="sm" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        </b-card>    
                        
                        <b-card>
                            <div slot="header">
                                <strong>Asignación Histórica</strong>
                            </div>
                            <b-button variant="primary" size="sm">Asignar Liquidador    <i class="fa fa-plus"></i></b-button>    
                            <br>
                            <br>
                            <b-row>
                                <b-col lg="10">             
                                    <div ref="refTable3">
                                        <data-tables ref="refTable3"
                                            :data="dataHistLiqu"
                                            name="tableHistLiqu"
                                            class="table-responsive"
                                            :current-page.sync="pagina"
                                            :table-props="tablePropsHistLiqu"
                                            :filters="filtersId"
                                            :page-size="10"
                                            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                                            layout="table">
                                            <b-col><b-button variant="outline-primary"><i class="fa fa-edit"></i></b-button></b-col>
                                            <el-table-column
                                                v-for="title in titlesHistLiqu"
                                                :min-width="title.minwidth" 
                                                :prop="title.prop"
                                                :label='title.label'
                                                :key="title.label"
                                                :align="title.align"
                                                sortable="custom"
                                                :formatter="formatter"
                                                name="table"
                                                class="table-responsive">
                                            </el-table-column>
                                            <b-col><b-button variant="primary" size="sm">Det.</b-button></b-col>
                                        </data-tables>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card> 

                        <div class="d-flex justify-content-around">
                            <b-button variant="primary" size="md">RECUPEROS</b-button>
                            <b-button variant="primary" size="md">Enviar Mail</b-button>   
                        </div>
                    
                    </b-container>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
// import apiGarSiniestros from "@/components/services/apiGarSiniestros";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';
import XLSX from "xlsx";


export default {
    name: "asigLiquidador",
    mixins: [tablasMixin, globalesMixin, utilesMixin],
  
    props: {
        deDonde: String,
        nroSiniestro: Number
    },

    components: {
        cSwitch,
        Datepicker,
        Multiselect
    },
    
    data: function() {
        return {
            tieneAcceso: false,
            es: es,
            busqueda: "",
            pagina: 1,
            paginaAnterior: 1,
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },

            datosFormulario:{
                dedonde:""
            },

            datosSiniestro:{
                nrosiniestro:"",
                nroaviso:"",
                nropoliza:"",
                producto:"",
                moneda:"",
                feingreso:"",
                estado:"",
                codasegurado:"",
                rutasegurado:"",
                nomasegurado:"",
                codsujetoriesgo:"",
                rutsujetoriesgo:"",
                nomsujetoriesgo:""
            },

            titlesHistLiqu: [   
                {
                prop: "servicio",
                label: "Servicio",
                align: "center",
                minwidth:'80'
                },
                {
                prop: "codigo",
                label: "Código",
                align: "center",
                minwidth:'100'
                },
                {
                prop: "nombre",
                label: "Nombre",
                align: "center",
                minwidth:'250'
                },
                {
                prop: "feinicio",
                label: "Fecha Inicio",
                align: "center",
                minwidth:'100'
                },
                {
                prop: "fetermino",
                label: "Fecha Término",
                align: "center",
                minwidth:'100'
                },
            ],
            
        };
    },        

    methods: {

        obt_datSiniestro(){
            console.log(this.$route.query.nroSiniestro);
            this.datosFormulario.dedonde = this.$route.query.deDonde;
            this.datosSiniestro.nrosiniestro = this.$route.query.nroSiniestro;
            this.tieneAcceso = true;
        },

    },

    mounted() {
        this.pagina = Number(this.$route.query.pagina);
        // this.pre_insertar();
        this.obt_datSiniestro();
        
    },

    watch: {
        pagina: function(nuevo, anterior) {
        this.paginaAnterior = anterior;
        }
    }


};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}

.col-sm-per{
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
}

.derecha   { 
  float: right; 
  color: #20a8d8;
}
.izquierda { 
  float: left;  
}

</style>